import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Img from 'gatsby-image';

import { fadeIn } from '../constants/keyframes';
import { TRANSITION_TIME_TOTAL } from '../constants/transitions';
import { fluidPropTypes } from '../types';

import { updateFluidSrcSetData } from '../helpers/image';

import DuoToneImage from './DuoToneImage';
import GrayImage from './GrayImage';


const AnimatedGrayImage = styled(GrayImage)`
  opacity: 0;
  will-change: opacity;
  animation: ${fadeIn} .6s linear ${TRANSITION_TIME_TOTAL}ms forwards;
`;


const MichelbergerImage = ({ changesColorOnHover, hasBlendMode, image }) => {
  const altText = image.alt || '';

  if (image.mimeType === 'image/svg+xml') {
    return (
      <img alt={altText} src={image.url} />
    );
  }

  if (hasBlendMode && changesColorOnHover) {
    return <DuoToneImage key={image.id} image={image} />;
  } if (hasBlendMode && !changesColorOnHover) {
    return <AnimatedGrayImage><Img key={image.id} alt={altText} fluid={updateFluidSrcSetData(image.fluid)} /></AnimatedGrayImage>;
  }

  return <Img key={image.id} alt={altText} fluid={updateFluidSrcSetData(image.fluid)} />;
};

MichelbergerImage.propTypes = {
  changesColorOnHover: PropTypes.bool,
  hasBlendMode: PropTypes.bool,
  image: PropTypes.shape({
    alt: PropTypes.string,
    id: PropTypes.string,
    mimeType: PropTypes.string,
    url: PropTypes.string,
    fluid: fluidPropTypes,
  }),
};

export default MichelbergerImage;
